import { call, put, takeLatest } from "redux-saga/effects";

import Axios from "../../utils/Axios";
import { FETCH_CLIENTS_FAILURE, FETCH_CLIENTS_REQUEST, FETCH_CLIENTS_SUCCESS } from "../Actions/Actions";
import AuthHandler from "../../utils/AuthHandler";
import { CLIENTS_DETAILS_LIST } from "../../config/API_Collection";
import { getErrorMessage } from "../../config/Error_Codes";

function* fetchClientsSaga() {
  try {
    const response = yield call(Axios.get, CLIENTS_DETAILS_LIST);
 
      yield put({ type: FETCH_CLIENTS_SUCCESS, payload: response.data.data || [] });
    
}catch(error){
    yield call(AuthHandler, error.response?.status); // optionally pass setToast/navigate as needed
    yield put({type:FETCH_CLIENTS_FAILURE,payload:getErrorMessage(error.status)});
}
}

export default function* clientsListSaga() {
  yield takeLatest(FETCH_CLIENTS_REQUEST, fetchClientsSaga);
}
